var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsGraphSocialRole(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17 9)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFBBE4",
    cx: 23,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FF79C9",
    cx: 23,
    cy: 40,
    rx: 23,
    ry: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.315 31.607a8.333 8.333 0 0 1 11.785 0 8.333 8.333 0 0 1 11.785 11.786L24.84 53.438a2.46 2.46 0 0 1-3.478 0L11.315 43.393l-.178-.183a8.333 8.333 0 0 1 .178-11.603z",
    fill: "#FFBBE4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphSocialRole);
export default __webpack_public_path__ + "static/media/icons_graph_social_role.11fdd911ff5499438b1276eb1183c840.svg";
export { ForwardRef as ReactComponent };